<!-- Modal Header -->
<div class="modal-header">
    <h3 class="modal-title">
        Add New Settlement
        <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
        <i class="fa pull-right"
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           style="margin-right: 10px; cursor: pointer;"
           (click)="minimise=!minimise"></i>
    </h3>
</div>

<!-- Modal Body -->
<div class="modal-body" style="padding-top: 0 !important;" [hidden]="minimise">
    <div class="row header-info-row">
        <table class="table table-bordered form-inline">
            <tr>
                <td><strong>Cdr No:</strong>
                    <div>
                        <input class="form-control input-md numText text_field_width" style="width: 100%;" type="text"
                            aria-describedby="basic-addon2" [disabled]="true" [(ngModel)]="rowData.CDR_NO">
                    </div>
                </td>
                <td><strong>Reporting Period:</strong>
                    <div>
                        <input class="form-control input-md numText text_field_width" style="width: 100%;" type="text"
                            aria-describedby="basic-addon2" [disabled]="true" [(ngModel)]="rowData.REPORTING_PERIOD">
                    </div>
                </td>
                <td><strong>ME Name:</strong>
                    <div>
                        <input class="form-control input-md numText text_field_width" style="width: 100%;" type="text"
                            maxlength="10" aria-describedby="basic-addon2" [disabled]="true"
                            [(ngModel)]="rowData.ME_NAME">
                    </div>
                </td>
                <td><strong>Leid:</strong>
                    <div>
                        <input class="form-control input-md numText text_field_width" style="width: 100%;" type="text"
                            maxlength="10" aria-describedby="basic-addon2" [disabled]="true"
                            [(ngModel)]="rowData.LEID">
                    </div>
                </td>
            </tr>
        </table>
    </div>

    <!-- Loading Spinner -->
    @if (loading) {
<div class="text-center" style="padding: 20px;">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    <!-- Main Content -->
    @if (!loading) {
<div class="settlement-content">
        <table class="table table-bordered form-inline InnerTblBG">
            <tbody>

            <!-- Federal Method of Settlement - Allocated -->
            <tr class="row">
                <td style="font-weight: bold;" class="row" colspan="12">
                    Federal Method of Settlement - Allocated
                </td>
            </tr>
            <tr class="row">
                <td colspan="12">
                    <table class="table table-bordered form-inline InnerTblBG">
                        <thead>
                            <tr>
                                <th class="row first">
                                    <p></p>
                                </th>
                                <th class="row">
                                    <p>Settlement Type</p>
                                </th>
                                <th class="row">
                                    <p>ADN-BUC Code/Other Codes</p>
                                </th>
                                <th class="row">
                                    <p>Amount</p>
                                </th>
                                <th class="row">
                                    <p>Action</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Add Details Row -->
                            <tr>
                                <td class="row">
                                    <i class="fa fa-plus-circle color-green fa-lg pull-right"
                                        style="cursor: pointer; margin-top: 4px;" title="Add Details"
                                        (click)="AddNewRow('Federal')">
                                    </i>
                                </td>
                                <td class="row" colspan="11">
                                    Add Details
                                </td>
                            </tr>
                            <!-- Federal Data Rows -->
                            @for (item of federalData; track trackByIndex(i, item); let i = $index) {

                                @if (item.IS_CHANGED_FLAG !== 'D') {
<tr>
                                    <!-- Read-Only Mode -->
                                    @if (item.IS_EDIT_MODE === 'N') {

                                        <td class="row">
                                            <p>
                                                <i class="fa fa-pencil bluepencil pull-left"
                                                    style="cursor: pointer; margin-top: 4px;" title="Edit Details"
                                                    (click)="editExistingRecord(item, 'Federal')">
                                                </i>
                                                <i class="fa fa-minus-circle color-red fa-lg pull-right"
                                                    style="cursor: pointer; margin-top: 4px;" title="Remove Details"
                                                    (click)="removeExistingRecord(item.OCCURRENCE, 'Federal')">
                                                </i>
                                            </p>
                                        </td>
                                        <td class="row">
                                            <p>{{ item.SETTLEMENT_TYPE }}</p>
                                        </td>
                                        @if (item.SETTLEMENT_TYPE === 'IBS') {
<td class="row">
                                            <p>{{ item.ADN_CODE }}-{{ item.BUC_CODE }}</p>
                                        </td>
}
                                        @if (item.SETTLEMENT_TYPE !== 'IBS') {
<td class="row">
                                            <p>{{ item.OTHER_DESC }}</p>
                                        </td>
}
                                        <td class="row">
                                            <p>{{ item.AMOUNT | numberWithCommas }}</p>
                                        </td>
                                        <td class="row">
                                        </td>
                                    
}

                                    <!-- Edit Mode -->
                                    @if (item.IS_EDIT_MODE === 'Y') {

                                        <td class="row">
                                            <i class="fa fa-check-circle color-green fa-lg pull-left"
                                                style="cursor: pointer; margin-top: 4px;" title="Save Details"
                                                (click)="saveNewEdittedRecord('Federal', item)">
                                            </i>
                                            <i class="fa fa-minus-circle color-red fa-lg pull-right"
                                                style="cursor: pointer; margin-top: 4px;" title="Remove Details"
                                                (click)="removeExistingRecord(item.OCCURRENCE, 'Federal')">
                                            </i>
                                        </td>
                                        <td class="row">
                                            <p>
                                                <select [(ngModel)]="item.SETTLEMENT_TYPE"
                                                    class="form-control fields">
                                                    <option value="">-- Select --</option>
                                                    @for (method of typesData; track $index) {
<option [value]="method.LABEL">
                                                        {{ method.LABEL }}
                                                    </option>
}
                                                </select>
                                            </p>
                                        </td>
                                        <!-- IBS: ADN and BUC dropdowns -->
                                        @if (item.SETTLEMENT_TYPE === 'IBS') {
<td class="row">
                                            <p class="col-md-6">
                                                <select [(ngModel)]="item.ADN_CODE"
                                                    class="form-control fields"
                                                    (change)="valuechanged('adn', 'Federal', item)">
                                                    <option value="">-- Select ADN --</option>
                                                    @for (method of federalCodes; track $index) {
<option [value]="method.ADN_CODE">
                                                        {{ method.ADN_CODE }}
                                                    </option>
}
                                                </select>
                                            </p>
                                            <p class="col-md-6">
                                                <select [(ngModel)]="item.BUC_CODE"
                                                    class="form-control fields"
                                                    (change)="valuechanged('buc', 'Federal', item)">
                                                    <option value="">-- Select BUC --</option>
                                                    @for (method of federalCodes; track $index) {
<option [value]="method.BUC_CODE">
                                                        {{ method.BUC_CODE }}
                                                    </option>
}
                                                </select>
                                            </p>
                                        </td>
}
                                        <!-- Non-IBS: Other Description -->
                                        @if (item.SETTLEMENT_TYPE !== 'IBS') {
<td class="row">
                                            <p>
                                                <input class="form-control input-md numText text_field_width"
                                                    style="width: 100%;" type="text" aria-describedby="basic-addon2"
                                                    [(ngModel)]="item.OTHER_DESC">
                                            </p>
                                            <div class="col-sm-12">
                                                @if (item.OTHER_DESC === '') {
<small class="text-danger">
                                                    Other Code cannot be empty.
                                                </small>
}
                                            </div>
                                        </td>
}
                                        <!-- Amount -->
                                        <td class="row">
                                            <p>
                                                <input type="text" class="form-control input-md numText fields"
                                                    placeholder="Amount"
                                                    [(ngModel)]="item.AMOUNT">
                                            </p>
                                            <div class="col-sm-12">
                                                @if (item.AMOUNT == 0) {
<small class="text-danger">
                                                    Amount cannot be 0.
                                                </small>
}
                                            </div>
                                        </td>
                                        <!-- Action Buttons -->
                                        <td class="row">
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-success"
                                                    (click)="add('Federal', item)" aria-label="Left Align">
                                                    <i class="fa fa-solid fa-calculator"
                                                        style="cursor: pointer; margin-top: 4px;"
                                                        title="Add Remaining Amount">
                                                    </i>
                                                </button>
                                                &nbsp;
                                                <button type="button" class="btn btn-default"
                                                    (click)="overwrite('Federal', item)" aria-label="Left Align">
                                                    <i class="fa fa-solid fa-rotate-right"
                                                        style="cursor: pointer; margin-top: 4px;"
                                                        title="Overwrite Remaining Amount">
                                                    </i>
                                                </button>
                                            </div>
                                        </td>
                                    
}
                                </tr>
}
                            
}
                        </tbody>
                    </table>
                </td>
            </tr>

            <!-- Federal Remaining Amount -->
            <tr class="row">
                <td colspan="12">
                    <div>
                        <span class="font-weight-bold text-success"><strong>Remaining Amount:</strong> </span>
                        <span class="font-weight-bold"><strong>Federal</strong> </span>
                        <span> ({{ remFederalAmt }})</span>
                    </div>
                </td>
            </tr>

            <!-- State Method of Settlement - Allocated -->
            <tr class="row">
                <td style="font-weight: bold;" class="row" colspan="12">
                    State Method of Settlement - Allocated
                </td>
            </tr>
            <tr class="row">
                <td colspan="12">
                    <table class="table table-bordered form-inline InnerTblBG">
                        <thead>
                            <tr>
                                <th class="row first">
                                    <p></p>
                                </th>
                                <th class="row">
                                    <p>Settlement Type</p>
                                </th>
                                <th class="row">
                                    <p>ADN-BUC Code/ Other Codes</p>
                                </th>
                                <th class="row">
                                    <p>Amount</p>
                                </th>
                                <th class="row">
                                    <p>Action</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Add Details Row -->
                            <tr>
                                <td class="row">
                                    <i class="fa fa-plus-circle color-green fa-lg pull-right"
                                        style="cursor: pointer; margin-top: 4px;" title="Add Details"
                                        (click)="AddNewRow('State')">
                                    </i>
                                </td>
                                <td class="row" colspan="11">
                                    Add Details
                                </td>
                            </tr>
                            <!-- State Data Rows -->
                            @for (item of stateData; track trackByIndex(i, item); let i = $index) {

                                @if (item.IS_CHANGED_FLAG !== 'D') {
<tr>
                                    <!-- Read-Only Mode -->
                                    @if (item.IS_EDIT_MODE === 'N') {

                                        <td class="row">
                                            <p>
                                                <i class="fa fa-pencil bluepencil pull-left"
                                                    style="cursor: pointer; margin-top: 4px;" title="Edit Details"
                                                    (click)="editExistingRecord(item, 'State')">
                                                </i>
                                                <i class="fa fa-minus-circle color-red fa-lg pull-right"
                                                    style="cursor: pointer; margin-top: 4px;" title="Remove Details"
                                                    (click)="removeExistingRecord(item.OCCURRENCE, 'State')">
                                                </i>
                                            </p>
                                        </td>
                                        <td class="row">
                                            <p>{{ item.SETTLEMENT_TYPE }}</p>
                                        </td>
                                        @if (item.SETTLEMENT_TYPE === 'IBS') {
<td class="row">
                                            <p>{{ item.ADN_CODE }}-{{ item.BUC_CODE }}</p>
                                        </td>
}
                                        @if (item.SETTLEMENT_TYPE !== 'IBS') {
<td class="row">
                                            <p>{{ item.OTHER_DESC }}</p>
                                        </td>
}
                                        <td class="row">
                                            <p>{{ item.AMOUNT | numberWithCommas }}</p>
                                        </td>
                                        <td class="row">
                                        </td>
                                    
}

                                    <!-- Edit Mode -->
                                    @if (item.IS_EDIT_MODE === 'Y') {

                                        <td class="row">
                                            <i class="fa fa-check-circle color-green fa-lg pull-left"
                                                style="cursor: pointer; margin-top: 4px;" title="Save Details"
                                                (click)="saveNewEdittedRecord('State', item)">
                                            </i>
                                            <i class="fa fa-minus-circle color-red fa-lg pull-right"
                                                style="cursor: pointer; margin-top: 4px;" title="Remove Details"
                                                (click)="removeExistingRecord(item.OCCURRENCE, 'State')">
                                            </i>
                                        </td>
                                        <td class="row">
                                            <p>
                                                <select [(ngModel)]="item.SETTLEMENT_TYPE"
                                                    class="form-control fields">
                                                    <option value="">-- Select --</option>
                                                    @for (method of typesData; track $index) {
<option [value]="method.LABEL">
                                                        {{ method.LABEL }}
                                                    </option>
}
                                                </select>
                                            </p>
                                        </td>
                                        <!-- IBS: ADN and BUC dropdowns -->
                                        @if (item.SETTLEMENT_TYPE === 'IBS') {
<td class="row">
                                            <p class="col-md-6">
                                                <select [(ngModel)]="item.ADN_CODE"
                                                    class="form-control fields"
                                                    (change)="valuechanged('adn', 'State', item)">
                                                    <option value="">-- Select ADN --</option>
                                                    @for (method of stateCodes; track $index) {
<option [value]="method.ADN_CODE">
                                                        {{ method.ADN_CODE }}
                                                    </option>
}
                                                </select>
                                            </p>
                                            <p class="col-md-6">
                                                <select [(ngModel)]="item.BUC_CODE"
                                                    class="form-control fields"
                                                    (change)="valuechanged('buc', 'State', item)">
                                                    <option value="">-- Select BUC --</option>
                                                    @for (method of stateCodes; track $index) {
<option [value]="method.BUC_CODE">
                                                        {{ method.BUC_CODE }}
                                                    </option>
}
                                                </select>
                                            </p>
                                        </td>
}
                                        <!-- Non-IBS: Other Description -->
                                        @if (item.SETTLEMENT_TYPE !== 'IBS') {
<td class="row">
                                            <p>
                                                <input class="form-control input-md numText text_field_width"
                                                    style="width: 100%;" type="text" aria-describedby="basic-addon2"
                                                    [(ngModel)]="item.OTHER_DESC">
                                            </p>
                                            <div class="col-sm-12">
                                                @if (item.OTHER_DESC === '') {
<small class="text-danger">
                                                    Other Code cannot be empty.
                                                </small>
}
                                            </div>
                                        </td>
}
                                        <!-- Amount -->
                                        <td class="row">
                                            <p>
                                                <input type="text" class="form-control input-md numText fields"
                                                    placeholder="Amount"
                                                    [(ngModel)]="item.AMOUNT">
                                            </p>
                                            <div class="col-sm-12">
                                                @if (item.AMOUNT == 0) {
<small class="text-danger">
                                                    Amount cannot be 0.
                                                </small>
}
                                            </div>
                                        </td>
                                        <!-- Action Buttons -->
                                        <td class="row">
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-success"
                                                    (click)="add('State', item)" aria-label="Left Align">
                                                    <i class="fa fa-solid fa-calculator"
                                                        style="cursor: pointer; margin-top: 4px;"
                                                        title="Add Remaining Amount">
                                                    </i>
                                                </button>
                                                &nbsp;
                                                <button type="button" class="btn btn-default"
                                                    (click)="overwrite('State', item)" aria-label="Left Align">
                                                    <i class="fa fa-solid fa-rotate-right"
                                                        style="cursor: pointer; margin-top: 4px;"
                                                        title="Overwrite Remaining Amount">
                                                    </i>
                                                </button>
                                            </div>
                                        </td>
                                    
}
                                </tr>
}
                            
}
                        </tbody>
                    </table>
                </td>
            </tr>

            <!-- State Remaining Amount -->
            <tr class="row">
                <td colspan="12">
                    <div>
                        <span class="font-weight-bold text-success"><strong>Remaining Amount:</strong> </span>
                        <span class="font-weight-bold"><strong>State</strong> </span>
                        <span> ({{ remStateAmt }})</span>
                    </div>
                </td>
            </tr>

            </tbody>
        </table>
    </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer pad-zero" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="disable">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()"
        [disabled]="disable">Reset</button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
